export enum DashboardAuthStatusEnum {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}
